export const drawer = {
	create: {
		title: "Ajouter un produit",
		notifications: {
			success: "Produit créé avec succès !",
			genericError: "Erreur lors de la création du produit.",
		},
		unsavedChanges: {
			title: "Quitter la création",
			message:
				"Êtes-vous sûr de vouloir quitter la création de ce produit ? " +
				"Vous perdrez les informations saisies jusqu'à présent.",
			cancel: "Annuler",
			confirm: "Quitter la création",
		},
	},
	edit: {
		title: "Modifier le produit",
		notifications: {
			success: "Produit mis à jour avec succès !",
			genericError: "Erreur lors de la mise à jour du produit",
			barUpdateError: "Échec de la mise à jour de certaines associations de bars.",
			barOperationsFailed:
				"{{ errorCount }} opérations de bar sur {{ total }} ont échoué.",
		},
		unsavedChanges: {
			title: "Quitter la modification",
			message:
				"Êtes-vous sûr de vouloir quitter la modification de ce produit ? " +
				"Vous perdrez les informations saisies jusqu'à présent.",
			cancel: "Annuler",
			confirm: "Quitter la modification",
		},
	},
	linkToBars: {
		title: "Associez votre produit aux bars",
		message:
			"Produit créé avec succès ! Il ne vous reste plus qu'à l'associer aux bars pour commencer à vendre",
		searchBars: "Rechercher des bars",
		selectPlaceholder: "Recherchez les bars disponibles pour lier",
		suggestionText: "Suggestions de bars",
		skip: "Passer",
		linkProduct: "Terminer",
		finishWithoutLinking: "Terminer sans lier",
		stock: "Inventaire",
		internalIp: "IP Interne",
		notifications: {
			success: "Produit associé avec succès au(x) bar(s) !",
			finishedWithoutLinking: "Produit créé avec succès !",
			error: "Échec de l'association du produit à {{ errorCount }} bar(s).",
			genericError: "Erreur lors de l'association du produit au(x) bar(s).",
			allFailed:
				"Échec de l'association du produit à tous les {{ total }} bars sélectionnés : {{ bars }}",
			partialSuccess:
				"Produit associé à {{ successCount }} bars sur {{ total }}. " +
				"{{ errorCount }} ont échoué : {{ failedBars }}",
		},
		success: {
			title: "Produit créé avec succès !",
			message:
				"Votre produit est maintenant actif dans les bars et vous pouvez également les configurer dans les bars.",
			understand: "Compris",
		},
	},
};
